import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Card,
  CardBody,
  Col,
  Row,
  ModalHeader
} from "reactstrap";
import {
  intToDateFormat,
  getInitValue
} from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";

import "toastr/build/toastr.min.css";
import { Formik, Field, Form } from "formik";
import { withTranslation } from "react-i18next";
import { getDomesticBankList,   getChargebackMonitoringSearch, getChargebackMonitoringList } from "store/actions";
import RavenFormikField from "components/Common/RavenFormikField";

const chargebackStatusName = {
  ResponseWaiting: "ResponseWaiting",
  MerchantAccepted: "MerchantAccepted",
  ResultWaiting: "ResultWaiting",
  BankAccepted: "BankAccepted",
  BankRefused: "BankRefused",
  Closed: "Closed"
 };
class ChargebackMonitoringSearchContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      record: "",
      recordList: [],
      filterSelected: "",
    };

  };
  handleSearch = values => {
    const { onGetChargebackMonitoringSearch } = this.props;
    onGetChargebackMonitoringSearch(values);
  };

  getChargeBackStatusListRenamed = (cbStatusRecordList) => {

    cbStatusRecordList.forEach(cbStatusRecord => {
     switch (cbStatusRecord.name) {
      case chargebackStatusName.ResponseWaiting:
        cbStatusRecord.name = "Is Yerinden Cevap Bekleniyor";
        break;
      case chargebackStatusName.MerchantAccepted:
        cbStatusRecord.name = "Is Yeri Itirazi Kabul Etti";
        break;
      case chargebackStatusName.ResultWaiting:
        cbStatusRecord.name = "Bankadan Cevap Bekleniyor";
        break;
      case chargebackStatusName.BankAccepted:
        cbStatusRecord.name = "Banka Dokümani Kabul Etti";
        break;
      case chargebackStatusName.BankRefused:
        cbStatusRecord.name = "Banka Dokümani Red Etti";
        break;
      case chargebackStatusName.Closed:
        cbStatusRecord.name = "Itiraz Kapatildi";
        break;
      default:
        break;
    }
    });
      
      return cbStatusRecordList;
  };

  render() {
    const { filterSelected } = this.state;
    return (
      <Row>
        <Col xs="12">
          <Card>
            <CardBody>
              <Formik
                enableReinitialize={true}
                disabled={true}
                initialValues={{
                  transactionStartDate: intToDateFormat(
                    filterSelected,
                    filterSelected.transactionStartDate,
                  ),
                  transactionEndDate: intToDateFormat(
                    filterSelected,
                    filterSelected.transactionEndDate,
                  ),
                  chargebackStartDate: intToDateFormat(
                    filterSelected,
                    filterSelected.chargebackStartDate,
                  ),
                  chargebackEndDate: intToDateFormat(
                    filterSelected,
                    filterSelected.chargebackEndDate,
                  ),
                  authorizationNumber: getInitValue(filterSelected, filterSelected?.authorizationNumber),
                  DomesticBankListGuid: getInitValue(filterSelected, filterSelected?.DomesticBankListGuid),
                  chargebackStatus: getInitValue(filterSelected, filterSelected?.chargebackStatusGuid),
                  chargebackNumber:  getInitValue(filterSelected, filterSelected?.chargebackNumber),
                  userName: localStorage.getItem("username"),
                }}
                onSubmit={values => {

                  if (values.transactionStartDate == undefined || values.transactionStartDate == "")
                  values.transactionStartDate = null;
                  if (values.transactionEndDate == undefined || values.transactionEndDate == "")
                  values.transactionEndDate = null;
                  if (values.chargebackStartDate == undefined || values.chargebackStartDate == "")
                  values.chargebackStartDate = null;
                  if (values.chargebackEndDate == undefined || values.chargebackEndDate == "")
                  values.chargebackEndDate = null;

                  values.userName = localStorage.getItem("username");

                    if (values.DomesticBankListGuid == undefined || values.DomesticBankListGuid == "")
                    values.DomesticBankListGuid = null;
                    values.userName = localStorage.getItem("username");
                    if (values.chargebackStatusGuid == undefined || values.chargebackStatusGuid == "")
                    values.chargebackStatusGuid = null;
                  this.handleSearch(values);
                }}
              >
                {({ errors, touched }) => (
                  <Form>
                    <Row>
                    </Row>
                    <Row>
                      <Col lg={12} className="col-12">
                        <div className="mb-3">
                          <details open={true}>
                            <summary>
                              {this.props.t("chargebackDate")}
                            </summary>

                            <Row>
                              <Col lg={6} className="col-7">
                                <Field
                                  name="chargebackStartDate"
                                  className="form-control"
                                  type="date"
                                />
                              </Col>

                              <Col lg={6} className="col-7">
                                <Field
                                  name="chargebackEndDate"
                                  className="form-control"
                                  type="date"
                                />
                              </Col>
                            </Row>

                          </details>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12} className="col-12">
                        <div className="mb-3">
                          <details open={true}>
                            <summary>
                              {this.props.t("transactionDate")}
                            </summary>

                            <Row>
                              <Col lg={6} className="col-7">
                                <Field
                                  name="transactionStartDate"
                                  className="form-control"
                                  type="date"
                                />
                              </Col>

                              <Col lg={6} className="col-7">
                                <Field
                                  name="transactionEndDate"
                                  className="form-control"
                                  type="date"
                                />
                              </Col>
                            </Row>

                          </details>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                    <Col lg={12}>
                          <div className="mb-3">
                            <details open={false}>
                              <summary>
                                {this.props.t("authorizationNumber")}
                              </summary>

                              <Field
                                name="authorizationNumber"
                                className={"form-control"}
                                type="text"
                              />

                            </details>
                          </div>
                        </Col>
                        <Col lg={12}>
                          <div className="mb-3">
                            <details open={false}>
                              <summary>
                                {this.props.t("chargebackNumber")}
                              </summary>

                              <Field
                                name="chargebackNumber"
                                className={"form-control"}
                                type="text"
                              />

                            </details>
                          </div>
                        </Col>
                      <Col lg={12} className="col-12">
                        <div className="mb-3">
                          <details open={true}>
                            <summary>
                              {this.props.t("chargebackStatusGuid")}
                            </summary>
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"chargebackStatusGuid"}
                              label={""}
                              component="multiselect"
                              type="singleselect"
                              valueList={this.getChargeBackStatusListRenamed(this.props.recordChargebackStatusList)}
                              nameOnValueList={"name"}
                            />
                          </details>
                        </div>
                      </Col>
                      <Col lg={12} className="col-12">
                          <div className="mb-3">
                            <details open={false}>
                              <summary>
                                {this.props.t("domesticBankListGuid")}
                              </summary>
                              <RavenFormikField
                                errors={errors}
                                touched={touched}
                                name={"DomesticBankListGuid"}
                                label={""}
                                component="multiselect"
                                type="singleselect"
                                valueList={this.props.recordBankList}
                                nameOnValueList={"bankName"}
                              />
                            </details>
                          </div>
                        </Col>
                    </Row>
                    <ModalHeader
                      style={{ marginBottom: "10px" }}
                    ></ModalHeader>
                    <Row>
                      <Col lg={10}>
                        <div style={{ textAlign: "right" }}>
                          <button
                            type="submit"
                            className="btn btn-success save-event"
                            style={{ marginRight: "3px" }}
                          >
                            {this.props.t("search")}
                          </button>

                          <button
                            type="reset"
                            className="btn btn-secondary save-customer"
                          >
                            {this.props.t("clear")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}
ChargebackMonitoringSearchContent.propTypes = {
  onGetChargebackMonitoringSearch: PropTypes.func,
  t: PropTypes.any,
  recordBankList: PropTypes.array,
  recordChargebackStatusList: PropTypes.array,
  recordList: PropTypes.array
};

const mapStateToProps = ({ domesticBankDefinition,chargebackStatusDef }) => ({
  recordBankList: domesticBankDefinition.recordList,
  recordChargebackStatusList:chargebackStatusDef.recordList,
});

const mapDispatchToProps = dispatch => ({
  onGetChargebackMonitoringSearch: filterSelected =>
  dispatch(getChargebackMonitoringSearch(filterSelected)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(ChargebackMonitoringSearchContent));